import { render, staticRenderFns } from "./storeStatistics.vue?vue&type=template&id=513328f9&scoped=true"
import script from "./storeStatistics.vue?vue&type=script&lang=js"
export * from "./storeStatistics.vue?vue&type=script&lang=js"
import style0 from "./storeStatistics.vue?vue&type=style&index=0&id=513328f9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513328f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513328f9')) {
      api.createRecord('513328f9', component.options)
    } else {
      api.reload('513328f9', component.options)
    }
    module.hot.accept("./storeStatistics.vue?vue&type=template&id=513328f9&scoped=true", function () {
      api.rerender('513328f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/storeStatistics.vue"
export default component.exports